import { render, staticRenderFns } from "./PaymentCmp.vue?vue&type=template&id=109460cc&scoped=true"
import script from "./PaymentCmp.vue?vue&type=script&lang=js"
export * from "./PaymentCmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109460cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('109460cc')) {
      api.createRecord('109460cc', component.options)
    } else {
      api.reload('109460cc', component.options)
    }
    module.hot.accept("./PaymentCmp.vue?vue&type=template&id=109460cc&scoped=true", function () {
      api.rerender('109460cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claimsManagement/claimList/cmp/Edit/PaymentCmp.vue"
export default component.exports